import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CommandContentStoreActions, CommandContentStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { PanelComponent } from '@rocksoft/cdk';
import { CommandProgress, MdmCommand } from '@rocksoft/mdm-sdk-v2';
import { Observable, of } from 'rxjs';
import { TimelineItemComponent } from './timeline.item.component';

@Component({
  selector: 'ml-timeline-ui',
  templateUrl: './timeline.item.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./timeline.item.container.scss'],
  imports: [PanelComponent, TimelineItemComponent, AsyncPipe],
})
export class TimelineComponent {
  private readonly store = inject(Store);

  readonly commands = input.required<CommandProgress[]>();

  getCommandContent(command: CommandProgress): Observable<MdmCommand | undefined> {
    const commandUUID = command.commandUUID;
    if (!commandUUID) {
      return of(undefined);
    }
    return this.store.select(CommandContentStoreSelectors.selectCommandContentById(commandUUID));
  }

  handleCommandContentRequest(event: { udid: string; commandUUID: string }) {
    this.store.dispatch(
      CommandContentStoreActions.CommandContentActions.commandContentRequested({
        udid: event.udid,
        commandUuid: event.commandUUID,
      })
    );
  }
}
